import { ReactNode } from 'react';

import { getLinks } from 'pages/matters/util';
import { CorrespondencePartyDto } from 'types/correspondence';
import { formatAddressSimple } from 'utils/addressFormatter';

const renderSuffix = (suffixParts: ReactNode[]) =>
    suffixParts.length > 0 ? (
        <span className="text-body1 leading-[inherit]">
            {suffixParts.map((part, i) => (
                // oxlint-disable-next-line react-doctor/no-array-index-as-key -- suffix parts are opaque ReactNodes without stable ids
                <span key={i}>{part} </span>
            ))}
        </span>
    ) : null;

export const getParties = (parties: CorrespondencePartyDto[]) => {
    return parties.map((party) => {
        const { mainParty, extraParty, correspondencePartyAddress } = party;
        const addressPart = correspondencePartyAddress ? (
            <>({formatAddressSimple(correspondencePartyAddress)})</>
        ) : null;

        if (mainParty === null) {
            return { ...extraParty, suffix: renderSuffix(addressPart ? [addressPart] : []) };
        }

        const suffixParts: ReactNode[] = [];
        if (extraParty) {
            suffixParts.push(<>({getLinks('contact', [extraParty])})</>);
        }
        if (addressPart) {
            suffixParts.push(addressPart);
        }
        return { ...mainParty, suffix: renderSuffix(suffixParts) };
    });
};
